import { useState } from "react";

{
    /* This hook manages the visibility of a list of products. It allows toggling between showing a limited number of products and all products. */
}

export function useVisibleProducts<T>(items: T[], defaultVisibleCount = 2) {
    const [showAll, setShowAll] = useState(false);

    const visibleItems = showAll ? items : items.slice(0, defaultVisibleCount);

    const toggleShowAll = () => setShowAll((prev) => !prev);

    return {
        visibleItems,
        showAll,
        toggleShowAll,
    };
}
